module.exports = function() {
  return new Worker("/" + "svelte-transpiler.9ca0e0b3.worker.js");
};